import React from 'react';
import { AD_ICON_PATHS } from './admin.constants';

interface ADIconProps {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

export function ADIcon({ name, size = 18, color = '#0f172a', style }: ADIconProps) {
  const path = AD_ICON_PATHS[name];
  if (!path) {
    return <span style={{ width: size, height: size, display: 'inline-block', ...style }} />;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={{ display: 'inline-block', flexShrink: 0, ...style }}>
      <path d={path} />
    </svg>
  );
}
